import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-21698888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Les laboratoires constituent des creusets d’échanges et de recherches sur des sujets d’actualité et de formation continue. Ils participent ainsi à la « pastorale de l’intelligence et de la raison qui crée une habitude de dialogue rationnel et d’analyse critique dans la société et dans l’Église » (Africæ munus, 137). "),
    /*#__PURE__*/_createElementVNode("h3", null, "Travaux"),
    /*#__PURE__*/_createElementVNode("li", null, "2025-2026 : Le respect de l’environnement "),
    /*#__PURE__*/_createElementVNode("li", null, "2024-2025 : L’Afrique à l’ère du numérique. Impact sur la vie socioculturelle et religieuse "),
    /*#__PURE__*/_createElementVNode("li", null, "2023-2024 : Formation civique à partir des défis de nos cultures")
  ])
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "blog-card style1" }
const _hoisted_6 = {
  class: "blog-info",
  style: {"min-height":"250px"}
}
const _hoisted_7 = { class: "blog-metainfo list-style" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))
const _hoisted_11 = { class: "row mb-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Nos laboratoires de recherche")
], -1))
const _hoisted_13 = { class: "axe-card" }
const _hoisted_14 = { class: "axe-icon" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/Charte des Laboratoires.pdf",
    download: "Charte des Laboratoires.pdf",
    class: "btn-download"
  }, " Télécharger Charte des laboratoires ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "blog-img",
                style: _normalizeStyle({height:'277px', backgroundImage: `url(${_ctx.getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'})
              }, null, 4),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  _createElementVNode("li", null, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createVNode(_component_router_link, { to: "#" }, {
                      default: _withCtx(() => [
                        _createTextVNode("L' École d’Initiation Théologique et Pastorale")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.titre), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.axes, (axe, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-6 col-md-6 mb-4",
            key: index
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("i", {
                  class: _normalizeClass(axe.icon)
                }, null, 2)
              ]),
              _createElementVNode("h4", null, _toDisplayString(axe.title), 1),
              _createElementVNode("p", null, _toDisplayString(axe.description), 1)
            ])
          ]))
        }), 128))
      ]),
      _hoisted_15
    ])
  ]))
}